import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import type { PostSpaceSummary } from "@circle-react/types/AiSummary/SpaceSummary";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { AiSummary } from "@/react/components/shared/AiSummary";

import { getAnimationDelay } from "./animations";
import { TopicsListV4 } from "./TopicsListV4";

interface SpaceTopicsListProps {
  topics: NonNullable<PostSpaceSummary["topics"]>;
}

export const TopicsList = (props: SpaceTopicsListProps) => {
  const { isCircleV4 } = useCircleV4();
  if (isCircleV4) return <TopicsListV4 {...props} />;
  return <TopicsListLegacy {...props} />;
};

const TopicsListLegacy = ({ topics }: SpaceTopicsListProps) => (
  <>
    <div
      className="animate-fade-in-slow mb-2 opacity-0"
      style={{
        animationDelay: getAnimationDelay(3),
        animationFillMode: "forwards",
      }}
    >
      <Typography.BodySm weight="medium" as="strong">
        {t("ai_spaces_summaries.takeaways")}
      </Typography.BodySm>
    </div>
    <ul className="space-y-2">
      {topics.map((topic, index) => (
        <li
          key={topic.topic_name}
          className="animate-fade-in-slow flex items-baseline opacity-0"
          style={{
            animationDelay: getAnimationDelay(index + 4),
            animationFillMode: "forwards",
          }}
        >
          <div className="flex-1">
            <div className="pt-1">
              <Typography.BodySm weight="bold" as="strong">
                {topic.topic_name}
              </Typography.BodySm>
            </div>
            <AiSummary.TextWithUserLinks
              text={topic.summary}
              relevantPosts={topic.relevant_posts}
            />
            {topic.summary_subcategories_by_author &&
              topic.summary_subcategories_by_author.length > 0 && (
                <ul className="space-y-1">
                  {topic.summary_subcategories_by_author.map(
                    (subcategory: string) => (
                      <li
                        key={`${topic.topic_name}-${subcategory}`}
                        className="animate-fade-in-slow flex items-baseline pl-2 opacity-0"
                        style={{
                          animationDelay: getAnimationDelay(index + 4),
                          animationFillMode: "forwards",
                        }}
                      >
                        <span className="mr-2">
                          <Typography.BodySm as="span">
                            {t("ai_spaces_summaries.bullet")}
                          </Typography.BodySm>
                        </span>
                        <AiSummary.TextWithUserLinks text={subcategory} />
                      </li>
                    ),
                  )}
                </ul>
              )}
          </div>
        </li>
      ))}
    </ul>
  </>
);
